<template>
<div class="nkn-social-media">
  <div class="common-sub-title">{{$t("news.socialMedia.title")}}</div>
  <div class="body-container">
    <div class="social-media-card">
      <div v-if="lang !== 'zh'" class="social-media-content content-media">
        <a  href="https://twitter.com/NKN_ORG?ref_src=twsrc%5Etfw" class="twitter-timeline">Loading</a>
      </div>
      <div v-else class="social-media-content content-media">
        <iframe class="weibo-news" height="732px" style="border:0;"  src="https://m.weibo.cn/u/6551363980"></iframe>
      </div>
      <div v-if="lang !== 'zh'" class="more-link"><a href="https://twitter.com/NKN_ORG" target="_blank">View more</a></div>
      <div v-else class="more-link"><a class="more-link" href="https://weibo.com/nknorg" target="_blank">更多资讯</a></div>
    </div>
    <div class="social-media-card">

      <div class="social-media-content content-news">
        <template v-if="newsArray">
          <news-module-zh v-for="(news, idx) in newsArray" :key="idx">
            <a :href="'https://forum.nkn.org/t/' + news.id" target="_blank" slot="news-title">{{news.title}}</a>
            <span slot="news-time">{{news.last_posted_at | timeFilter}}</span>
            <img v-lazy="news.image_url" slot="news-pic" class="pic-news-Redemption">
          </news-module-zh>
        </template>
      </div>

      <div v-if="lang === 'zh'" class="more-link"><a class="more-link" href="https://forum.nkn.org/c/chinese/xinwen" target="_blank">更多资讯</a></div>
      <div v-else class="more-link"><a href="https://forum.nkn.org/c/community/news" target="_blank">View more</a></div>
    </div>
  </div>
</div>
</template>

<script>
import NewsModule from '@/components/news/plugins/NewsModule'
import NewsModuleZh from '@/components/news/plugins/NewsModuleZh'
import {mapState} from 'vuex'
import $ from 'jquery'
import serverApi from '../../tasks/nknServerApi'
import nknStorage from '@/assets/js/nknStorage'


function checkClient () {
  let clientWidth = document.body.clientWidth

  if (clientWidth <= 768) {
    $('iframe').attr('scrolling', 'no')
  }
}

export default {
  data() {
    return {
      newsArr: {
        en:[],
        zh:[],
      },
      newsArray: []
    }
  },
  components: {
    NewsModule,
    NewsModuleZh
  },
  created : async function(){

  },
  mounted: async function () {

    this.$nextTick(async () => {
      checkClient()
      await this.getNews()
    })


  },
  computed: {
    ...mapState({
      lang: state => state.lang.lang
    })
  },
  methods: {
    getNews : async function() {
      const prefixUrl = "https://explorer.nkn.org/api/forum/news";
      let pathUrl = "/c/community/news.json";

      if(this.lang === "zh") {
        pathUrl = "/c/chinese/xinwen.json";
      }
      let accessUrl = prefixUrl + pathUrl;
      let resp = await this.$http.get(accessUrl)

        if (resp.status === 200&&resp.data&&resp.data.topic_list) {
          this.newsArray = resp.data.topic_list.topics
          this.dataSort('created_at');
          //console.log(this.newsArray);
        }


    },
    dataSort(keyName) {
      const arrObj = function (keyName) {
        return function (obj1, obj2) {
          const val1 = obj1[keyName]
          const val2 = obj2[keyName]
          if (val1 < val2) {
            return 1
          } else if (val1 > val2) {
            return -1
          } else {
            return 0
          }
        }
      }
      this.newsArray.sort(arrObj(keyName))
    }
  },
  filters: {
    timeFilter(val) {
      return val.substring(0 ,10)
    }
  }
}
</script>

<style lang="scss" scoped>
.nkn-social-media {
  .body-container{display: flex;flex-wrap: wrap;}
  .weibo-news {
    width: 100%;
    @media screen and (max-width: 768px) {
      /*width: 300px;*/
    }
  }
  margin-top: 80px;
  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
  .common-sub-title {
    text-align: left;
    padding-left: 15px;
  }
  .social-media-card {
    flex-grow: 1; width: 50%;
    padding: 0 15px; min-width: 300px;
    @media screen and (max-width: 768px) {
      /*width: 100%;*/
      padding: 0 15px;
      margin-bottom: 30px;
      .social-media-content {
        height: 400px !important;
        overflow: scroll;
      }
    }
  }
  .more-link {
    margin-right: -5px;
    @media screen and (max-width: 768px) {
      margin-right: 0;
    }
  }
  .more-link a {
    display: inline-block;
    font-size: 14px;
    color: #1791f2;
    width: 134px;
    height: 50px;
    line-height: 50px;
    margin-top: 20px;
    text-align: center;
    border: 1px solid #1791f2;
    border-radius: 4px;
    transition: all 0.2s;
  }
  .more-link:hover a {
    color: #ffffff;
    background-color: #1791f2;
    text-decoration: none !important;
  }
  .social-media-content {

    height: 36.5rem;
    box-sizing: border-box;
    overflow: auto;
    margin-top: 10px;
    padding: .5rem 1.5rem;
    box-shadow: 0 0 1rem .05rem #d6dbee;
    @media screen and (max-width:768px){
      width: 100%;
      iframe::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 1rem;
      background: #dedede;
    }

    &::-webkit-scrollbar-track {
      border-radius: 0;
      background: #fff;
    }
  }

  .content-news {
    &>div+div {
      border-top: .05rem solid #c2c5cc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/nknSocialMedia.vue